module.exports = __webpack_public_path__ + "img/karakters-17.a57cd105.jpg";